﻿(function (angular, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Factories").factory("RangeTrimApi", [
    "$q",
    "$filter",
    "API",
    "DebugLogger",
    function ($q, $filter, API, DebugLogger) {
      function getById(trimId, pricingParams) {
        if (pricingParams) {
          // This service looks up usageType by itself, so we don't need to pass usageType
          return API.get(
            $filter("formatArgs")(ToyotaConsts.API.Vehicle.TrimsWithPricingOptions, [trimId, pricingParams.postcode])
          ).then(function (response) {
            if (!response.data.success) {
              DebugLogger.log("RangeTrimApi", "getById (with pricing params): server responded with falsy success");
              throw new Error("RangeTrimApi.getById (with pricing params): server responded with falsy success");
            }

            return response.data;
          });
        }

        return API.get($filter("formatArgs")(ToyotaConsts.API.Vehicle.Trims, [trimId])).then(function (response) {
          if (!response.data.success) {
            DebugLogger.log("RangeTrimApi", "getById (no pricing params): server responded with falsy success");
            throw new Error("RangeTrimApi.getById (no pricing params): server responded with falsy success");
          }

          return response.data;
        });
      }

      return {
        getById: getById,
      };
    },
  ]);
})(window.angular, window.ToyotaConsts);
